import { useEffect } from "react";

import useAuthorization from "./useAuthorization";

export function useDisableFormsIfReadOnly() {
  const { full: user } = useAuthorization({ load: false });

  useEffect(() => {
    if (!user) return;

    const readOnly =
      !user.allowCreate && !user.allowUpdate && !user.allowDelete;

    if (!readOnly) return;

    const disableForms = () => {
      document.querySelectorAll("form").forEach((form) => {
        form
          .querySelectorAll(
            "form input, form select, form textarea, form button"
          )
          .forEach((el) => {
            el.disabled = true;
          });
      });
    };

    const frame = requestAnimationFrame(disableForms);

    const observer = new MutationObserver(() => {
      disableForms();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
    };
  }, [user]);
}
